import { Injectable } from '@angular/core';
import { DataSeries } from '@next/core-lib/models';

@Injectable({
  providedIn: 'root',
})
export class FlockDataSeriesService {
  constructor() {}

  filterDataSeries(
    flockId: number,
    dataSeries: DataSeries<number, number>,
    kpi: string,
    relatedKpis: string[] = [],
  ): DataSeries<number, number> {
    const parameterCodes = [kpi, ...relatedKpis];
    let dataSerieList = parameterCodes.flatMap((parameterCode) =>
      (dataSeries?.series?.[flockId] ?? []).filter(
        (serie) => serie.parameterCode === parameterCode,
      ),
    );

    if (relatedKpis.length) {
      dataSerieList = dataSerieList.filter((serie) =>
        serie.values.some(({ value }) => Number.isFinite(value)),
      );
    }

    const availableParameterCodes = new Set(dataSerieList.map((serie) => serie.parameterCode));
    const dataParameters = parameterCodes.flatMap((parameterCode) =>
      (dataSeries?.metaData?.parameters ?? []).filter(
        (parameter) =>
          parameter.code === parameterCode &&
          (!relatedKpis.length || availableParameterCodes.has(parameter.code)),
      ),
    );

    // Construct new data-serie with only holding the parameter we need.
    const newDataSerie: DataSeries<number, number> = {
      metaData: {
        parameters: dataParameters,
      },
      series: {
        [flockId]: dataSerieList,
      },
    };

    return newDataSerie;
  }
}
